<div class="bold">{{confirmLogMessage}} </div>
<div class="pt-pix-10">
  <ng-table #gridComponent [search]="false" [paginator]="false" [scrollable]="true" [scrollHeight]="'300px'"
    [columns]="productColumns" [data]="salesInventoryProducts">
  </ng-table>
</div>
